import { createFileRoute } from '@tanstack/react-router'

import { ClassificationListView } from '@/components/Internal/ProductClassification/ClassificationListView'
import { GroupPropertiesSection } from '@/components/Internal/ProductProperty/GroupPropertiesSection'

export const Route = createFileRoute(
  '/internal/system/administration/classifications/groups',
)({
  component: () => (
    <ClassificationListView
      kind="GROUP"
      // A group is the one list whose entries say something beyond their
      // name: what a product of that group is measured in.
      renderExpanded={entry => <GroupPropertiesSection groupId={entry.id} />}
    />
  ),
})
